import { SplitLayout } from '@components/layout';
import { AuthenticationHeader } from '@components/layout/authentication/AuthenticationHeader';
import { usePrefixedNavigate } from '@hooks/usePrefixedNavigate';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { Button, ButtonProps, Typography } from '@mui/material';
import Alert from '@mui/material/Alert/Alert';
import clsx from 'clsx';
import { ReactElement, useEffect } from 'react';
import { LinkProps, useLocation } from 'react-router-dom';

type Props = {
    title: string | ReactElement;
    message: ReactElement;
    primaryButtonProps: ButtonProps & { to?: LinkProps['to'] };
    secondaryButtonProps?: ButtonProps & { to?: LinkProps['to'] };
    stateVariable?: string;
};

const AuthenticationSuccess = ({ title, message, primaryButtonProps, secondaryButtonProps, stateVariable }: Props) => {
    const { state: routeState } = useLocation();
    const navigate = usePrefixedNavigate();

    useEffect(() => {
        if (stateVariable) {
            if (!routeState?.[stateVariable]) {
                navigate({ pathname: '/auth/login', search: window.location.search }, { replace: true });
                return;
            }

            window.history.replaceState(
                { ...routeState, [stateVariable]: false },
                document.title,
                window.location.pathname + window.location.search
            );
        }
    }, []);

    return (
        <SplitLayout>
            <AuthenticationHeader />
            <Alert severity="success" icon={<CheckCircleOutlineIcon color="check-confirm" />}>
                <Typography fontFamily="Roboto" fontWeight={500} fontSize={16}>
                    {title}
                </Typography>
                {message}
            </Alert>
            <Button
                fullWidth
                {...primaryButtonProps}
                className={clsx('rounded-full black-border mt-6', primaryButtonProps.className)}
            />
            {secondaryButtonProps ? (
                <Button
                    fullWidth
                    color="white"
                    {...secondaryButtonProps}
                    className={clsx('rounded-full black-border mt-4', secondaryButtonProps.className)}
                />
            ) : null}
        </SplitLayout>
    );
};

export { AuthenticationSuccess };
